import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';


const EditServiceTicket = () => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);


  return (
    <EditForm title={"Repair"} initialValues={initialValues} fields={formFields} schema={schema} url={"repairs"}>
      
     </EditForm>
  );
}

export default EditServiceTicket;